<template>
  <div class="phone_page">
    <Tabbar :title="$t('transfer.transfer')"></Tabbar>
    <div class="phone_area">
      <div class="content_item" :class="[$store.state.isMirroring && 'mirror']">
        <div class="content_item_title required cashout" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('basicLevel.cashOut') }}
        </div>
        <div class="content_item_select" type="text" @click="showPicker = true">
          {{ toAccount ? toAccount : $t('rechargeAndTransfer.search') }}
          <img class="content_item_select_icon" src="@/assets/transfer/select_icon.png" alt="" />
        </div>
      </div>
      <div class="content_item" :class="[$store.state.isMirroring && 'mirror']">
        <div class="content_item_title required" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('transfer.transfer') }}
        </div>
        <div class="content_item_input_box" @click="showKeyboard = true">
          <span class="amount_prefix">$</span>
          <input
            class="content_item_input"
            v-model="amount"
            type="text"
            readonly
            @focus="showKeyboard = true"
            @blur="checkValidAmount"
          />
          <img v-show="amount" class="delete_icon" src="@/assets/transfer/delete.png" alt="" @click="amount = ''" />
        </div>
        <div class="content_item_note">
          {{ amountPlaceholder }}
          <div class="all_btn" @click="all">{{ $t('home.all') }}</div>
        </div>
      </div>
      <div v-if="!allowTransfer && notAllowReason" class="not_allow_reason">
        {{ notAllowReason }}
      </div>
      <div class="note">
        {{ $t('rechargeAndTransfer.transfer_limit_2') }}
      </div>
      <div class="done_btn_area">
        <p :class="allowTransfer ? 'done_btn' : 'done_btn disabled'" @click="showConfirmDialog = true">
          {{ $t('transfer.transfer') }}
        </p>
      </div>
    </div>
    <!-- 钻代搜索 -->
    <van-popup v-model="showPicker" position="bottom" :close-on-click-overlay="false" @close="onClose">
      <div class="picker_box">
        <img
          :class="$store.state.isMirroring && 'mirror'"
          class="close"
          src="@/assets/close.png"
          @click="showPicker = false"
        />
        <div class="picker_title">{{ $t('rechargeAndTransfer.search') }}</div>
        <div class="input_box">
          <CommonInput
            class="search_input"
            type="text"
            theme="primary"
            auto-focus
            :placeholder="$t('rechargeAndTransfer.search')"
            v-model="searchParam"
          >
            <template>
              <img
                v-show="searchParam"
                class="search_icon"
                src="@/assets/transfer/search_icon.png"
                alt=""
                @click="search"
              />
            </template>
          </CommonInput>
        </div>
        <div v-if="showResult" class="result_box">
          <div v-if="result && result.account" class="result_item" @click="selectUser(result.account)">
            <img class="selected_icon" src="@/assets/transfer/selected.png" alt="" />
            <div>
              <div class="username">
                {{ result.name }}
                <div class="userid">(ID: {{ result.userId }})</div>
              </div>
              <div class="account">{{ result.account }}</div>
            </div>
          </div>
          <NoData v-else class="no_data" />
        </div>
        <div v-else class="result_box">
          <div class="result_title">
            {{ $t('rechargeAndTransfer.history') }}
          </div>
          <div v-if="historyList && historyList.length > 0">
            <div class="result_item" v-for="item in historyList" :key="item" @click="selectUser(item)">
              <img class="selected_icon" src="@/assets/transfer/selected.png" alt="" />
              <div>{{ item }}</div>
            </div>
          </div>
          <NoData v-else class="no_data" />
        </div>
      </div>
    </van-popup>
    <!-- 等待转账结果 -->
    <van-popup v-model="loadingShow">
      <van-loading class="spinner_box" type="spinner" color="#378E5B" />
    </van-popup>
    <!-- 转账确认弹框 -->
    <van-popup v-model="showConfirmDialog">
      <div class="dialog_box">
        <div class="dialog_title">{{ $t('transfer.transfer') }}</div>
        <div class="dialog_content">
          <i18n path="rechargeAndTransfer.confirm_content" tag="span">
            <span class="highlight">${{ amount }}</span>
            <span class="highlight">{{ toAccount }}</span>
          </i18n>
        </div>
        <div class="dialog_footer">
          <div class="cancel_btn" @click="showConfirmDialog = false">
            {{ $t('common.cancel') }}
          </div>
          <div class="confirm_btn" @click="onConfirm">
            {{ $t('common.confirm') }}
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 转账成功弹框 -->
    <van-popup v-model="showSuccessDialog" @click-overlay="onExit">
      <div class="dialog_box">
        <div class="dialog_title">
          <img class="success_icon" src="@/assets/transfer/success.png" alt="" />
        </div>
        <div class="dialog_content">
          <i18n path="rechargeAndTransfer.success_content" tag="span">
            <span class="highlight">${{ amount }}</span>
            <span class="highlight">{{ toAccount }}</span>
          </i18n>
        </div>
        <div class="dialog_footer">
          <div class="confirm_btn" @click="onExit">
            {{ $t('common.confirm') }}
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 支付密码 -->
    <CheckPayPassword
      :show="paymentCodeShow"
      v-bind:on-success="onPasswordSuccess"
      v-bind:on-failed="onPasswordFailed"
      v-bind:on-close="onClosePaymentCode"
    />
    <!-- 设置支付密码 -->
    <PaymentCodeSetPopup v-model="showPaymentCodeSetPopup" />
    <!-- 数字键盘 -->
    <van-number-keyboard
      v-model="amount"
      :show="showKeyboard"
      @blur="showKeyboard = false"
      get-container="#app"
      z-index="3000"
    />
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar'
import NoData from '@/components/noData.vue'
import PopWindow from '@/components/PopWindow'
import CheckPayPassword from '@/components/CheckPayPassword'
import CommonInput from '@/components/CommonInput.vue'
import { Dialog, Toast } from 'vant'
import throttle from 'lodash/throttle'
import PaymentCodeSetPopup from '@/components/PaymentCode/PaymentCodeSetPopup.vue'
import { spendableCents } from '@/utils'

export default {
  name: 'Transfer',
  components: {
    Tabbar,
    NoData,
    PopWindow,
    CheckPayPassword,
    CommonInput,
    PaymentCodeSetPopup
  },
  data() {
    return {
      toAccount: '',
      amount: '',
      showPicker: false,
      showResult: false,
      result: undefined,
      searchParam: '',
      historyList: [],
      balance: this.$store.state.balance,
      allowTransfer: false,
      notAllowReason: '',
      loadingShow: false,
      paymentCodeShow: false,
      showConfirmDialog: false,
      showSuccessDialog: false,
      showKeyboard: false,
      showPaymentCodeSetPopup: false
    }
  },
  watch: {
    showPaymentCodeSetPopup: {
      handler(newVal, oldVal) {
        if (oldVal && !newVal) {
          this.$router.back()
        }
      }
    },
    amount() {
      this.checkValidAmount()
    }
  },
  computed: {
    amountPlaceholder() {
      return this.$t('withdrawAccount.availableBalance', [
        new Intl.NumberFormat('en', {
          style: 'currency',
          currency: 'USD',
          currencyDisplay: 'symbol',
          minimumFractionDigits: 0
        }).format(spendableCents(this.balance) / 100)
      ])
    }
  },
  created() {
    this.getHistoryTransfer()
    // 检查支付密码和用户是否存在
    this.hasPayPassword()
      .then((res) => {
        if (!res) {
          // 未设置支付密码
          Dialog.confirm({
            message: this.$t('transfer.noPayPwdDialog'),
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel')
          })
            .then(() => {
              this.showPaymentCodeSetPopup = true
            })
            .catch(() => {
              this.$router.back()
            })
        }
      })
      .catch((err) => {
        Toast({ message: err })
      })
  },
  methods: {
    getHistoryTransfer() {
      this.$http.post(window.serverPath + '/api/transfer/getHistoryTransfer').then((res) => {
        if (res.data.code === '200') {
          this.historyList = res.data.data
        }
      })
    },
    all() {
      const cents = spendableCents(this.balance)
      if (cents > 3000000) {
        this.amount = '30000'
      } else if (cents >= 1000) {
        this.amount = (cents / 100).toFixed(2)
      }
    },
    search: throttle(function () {
      this.$http
        .post(window.serverPath + '/api/transfer/searchAgent', {
          account: this.searchParam
        })
        .then((res) => {
          if (res.data.code === '200') {
            this.result = res.data.data
            this.showResult = true
          } else {
            this.result = undefined
            this.showResult = true
            Toast({ message: res.data.message })
          }
        })
    }, 1000),
    checkValidAmount() {
      console.log(this.amount)
      if (!this.amount) {
        this.notAllowReason = ''
        this.allowTransfer = false
      } else if (!this.isNumber(this.amount)) {
        this.notAllowReason = this.$t('rechargeAndTransfer.invalid_number')
        this.allowTransfer = false
      } else if (Number(this.amount) < 10) {
        this.notAllowReason = this.$t('rechargeAndTransfer.under_limit')
        this.allowTransfer = false
      } else if (Number(this.amount) > 30000) {
        this.notAllowReason = this.$t('rechargeAndTransfer.over_limit')
        this.allowTransfer = false
      } else if (Number(this.amount) > Number(this.balance)) {
        this.notAllowReason = this.$t('rechargeAndTransfer.insufficient_balance')
        this.allowTransfer = false
      } else {
        this.notAllowReason = ''
        this.allowTransfer = true
      }
      if (!this.toAccount) {
        this.allowTransfer = false
      }
    },
    onClose() {
      this.showResult = false
      this.searchParam = ''
      this.result = undefined
      this.checkValidAmount()
    },
    selectUser(account) {
      this.toAccount = account
      this.showPicker = false
      this.showResult = false
      this.searchParam = ''
      this.result = undefined
    },
    hasPayPassword() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(window.serverPath + '/api/auth/hasPayPassword')
          .then((res) => {
            if (res.data && res.data.code === '200') {
              if (res.data.data) {
                resolve(true)
              } else {
                // 未设置支付密码
                resolve(false)
              }
            }
            // 接口返回异常
            reject(new Error('Request failed!'))
          })
          .catch((err) => reject(err))
      })
    },
    isEmail(account) {
      const regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      return regEmail.test(account)
    },
    isNumber(str) {
      const regNum = /^(0|[1-9][0-9]*)(\.\d{1,2})?$/
      return regNum.test(str)
    },
    onConfirm() {
      this.showConfirmDialog = false
      this.paymentCodeShow = true
    },
    onExit() {
      this.showSuccessDialog = false
      this.$router.push('/')
    },
    onPasswordSuccess(value) {
      this.loadingShow = true
      this.paymentCodeShow = false
      const data = {
        amount: this.amount.toString().replaceAll(',', ''),
        currency: 'USD',
        remark: '',
        securityToken: value.securityToken
      }
      if (this.isEmail(this.toAccount)) {
        data.relatedEmail = this.toAccount
      } else {
        data.relatedPhone = this.toAccount
      }
      this.$http.post(window.serverPath + '/api/transfer/confirm', data).then((res) => {
        if (res.data && res.data.code === '200') {
          this.loadingShow = false
          this.showSuccessDialog = true
        } else {
          this.loadingShow = false
          Toast({
            message: res.data.message
          })
        }
      })
    },
    onPasswordFailed(err) {
      console.log(this.$t('paymentCode.payPwdWrongToast'), err)
    },
    onClosePaymentCode() {
      this.paymentCodeShow = false
    }
  }
}
</script>

<style scoped>
.phone_page {
  width: 100%;
  background-color: #efefef;
  position: relative;
  min-height: 100%;
}

.phone_area {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.2rem;
}

.done_btn_area {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 0.12rem;
}

.done_btn {
  width: 3.38rem;
  height: 0.5rem;
  color: #fff;
  font-size: 0.16rem;
  text-align: center;
  line-height: 0.5rem;
  border-radius: 0.5rem;
  background-color: #3fbb70;
  border-radius: 8px;
}

.done_btn.disabled {
  /* opacity: 0.6; */
  background-color: #c6c6c6;
  pointer-events: none;
}

.icon_detail {
  width: 0.24rem;
  height: 0.24rem;
  padding: 0.02rem;
}

.content_item {
  background: #fff;
  width: 100%;
  border-radius: 0.16rem;
  margin-top: 0.12rem;
  padding: 0 0.16rem;

  &.mirror {
    justify-content: right;
  }
}

.content_item:last-child {
  border-bottom: none;
  /* height: 1rem; */
  align-items: start;
  padding-top: 0.19rem;
}

input {
  background: none;
  outline: none;
  border: none;
  margin: 0;
}

input:focus {
  border: none;
}

input::-webkit-input-placeholder {
  color: #bfbfbf;
  font-size: 0.16rem;
}

.content_item_title {
  font-size: 0.12rem;
  color: #2f2f2f;
  width: 100%;
  height: 0.44rem;
  line-height: 0.44rem;
  text-align: left;
  font-weight: bold;

  &.mirror {
    text-align: right;
  }
}

.cashout {
  border-bottom: 1px solid #e4e4e4;
}

.content_item_input {
  text-align: left;
  font-size: 0.36rem;
  font-weight: 600;
  width: 100%;
  &.mirror {
    text-align: left;
  }
}

.content_item_input_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 0.48rem;
  border-bottom: 1px solid #efefef;
  position: relative;
}

.amount_prefix {
  color: #2f2f2f;
  font-size: 0.36rem;
  font-weight: 600;
}

.delete_icon {
  position: absolute;
  right: 0rem;
  top: 0.14rem;
  width: 0.24rem;
  height: 0.24rem;
}

.all_btn {
  color: #3fbb70;
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 0.24rem;
}

.content_item_note {
  color: #b5aec0;
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 0.2rem;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 0.44rem;
}

.content_item_select {
  color: #aaa;
  font-size: 0.16rem;
  font-weight: 400;
  line-height: 0.24rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 0.6rem;
}

.content_item_select_icon {
  width: 0.1rem;
  height: 0.1rem;
  margin-inline-start: 0.04rem;
}

.not_allow_reason {
  text-align: left;
  color: red;
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.note {
  margin-top: 0.12rem;
  text-align: left;
  color: #aaa;
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.picker_box {
  height: 5rem;
  padding: 0.12rem 0.2rem;
  border-radius: 0.18rem 0.18rem 0px 0px;
  background: #fff;
}

.close {
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.24rem;
  height: 0.24rem;
}

.close.mirror {
  left: 0.24rem;
  right: auto;
}

.picker_title {
  display: flex;
  color: #2f2f2f;
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
  margin-bottom: 0.2rem;
}

.input_box {
  display: flex;
  position: relative;
}

.search_input {
  display: flex;
  height: 0.4rem;
  padding: 0.1rem 0.16rem;
  margin-bottom: 0.2rem;
  align-items: center;
  width: 100%;
  border-radius: 0.08rem;
  background: linear-gradient(90deg, rgba(67, 215, 125, 0.15) 0%, rgba(63, 187, 112, 0.15) 100%);
}

.search_icon {
  position: absolute;
  right: 0.16rem;
  top: 0.08rem;
  width: 0.24rem;
  height: 0.24rem;

  &.mirror {
    left: 0.16rem;
    right: auto;
  }
}

.result_title {
  margin-bottom: 0.08rem;
  display: flex;
  color: #2f2f2f;
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.24rem;
}

.result_item {
  display: flex;
  align-items: center;
  height: 0.48rem;
  color: #2f2f2f;
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  border-bottom: 0.01rem solid #efefef;
}

.selected_icon {
  width: 0.14rem;
  height: 0.14rem;
  margin-inline-end: 0.08rem;
}

.username {
  display: flex;
  color: #2f2f2f;
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  align-items: center;
}

.userid {
  display: flex;
  color: #828282;
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
  margin-inline-start: 0.04rem;
}

.account {
  display: flex;
  color: #828282;
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.no_data {
  margin-top: 0.88rem;
}

.dialog_box {
  display: flex;
  width: 3.27rem;
  padding: 0.24rem;
  flex-direction: column;
  align-items: center;
  border-radius: 24px;
  background: #fff;
  box-sizing: border-box;
}

.dialog_title {
  color: #2f2f2f;
  font-size: 0.18rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.26rem;
  margin-bottom: 0.12rem;
}

.success_icon {
  width: 0.8rem;
  height: 0.8rem;
}

.dialog_content {
  color: #5b5b5b;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.24rem;
}

.highlight {
  color: #3fbb70;
}

.dialog_footer {
  height: 0.5rem;
  width: 100%;
  margin-top: 0.24rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirm_btn {
  height: 0.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.08rem;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%);
  color: #fff;
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.24rem;
}

.cancel_btn {
  height: 0.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.08rem;
  background: #fff;
  border: 0.01rem solid #3fbb70;
  color: #3fbb70;
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.24rem;
  margin-inline-end: 0.12rem;
}

.spinner_box {
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/Transfer.vue